// ------------------------------------------------------------------------------
// PrimaryTabs
// author: mudas
// created: 2025/1/10
// ------------------------------------------------------------------------------

import React, { FC } from 'react';
import { Tabs, TabsProps } from '@fuxi/eevee-ui';

import cx from './PrimaryTabs.module.less';

export interface IProps extends TabsProps {}

const PrimaryTabs: FC<IProps> = props => {
  return <Tabs animated={false} className={cx('primary-tabs')} {...props} />;
};

export default PrimaryTabs;
